// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__K-lLF","card":"style_card__4ZvSZ","btnClose":"style_btnClose__nEDmf","title":"style_title__lFqby","body":"style_body__kAunm","footer":"style_footer__90Ryk"};